export default "__VITE_ASSET__D4yETR0l__"